import { List } from "immutable";

import { SemanticCategory } from "@seneca/tags-service-consts";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import Category from "../../models/Category";
import { normalizeString } from "../utils";
import * as category from "./category";

type CategoryId = string;
type State = Map<CategoryId, Category>;

export function getCategory(categories: State, categoryId: CategoryId) {
  return categories.get(categoryId);
}

export function getCategoryIds(categories: State) {
  // @ts-ignore
  return categories.keySeq();
}

export function getCategoryValues(categories: State) {
  // @ts-ignore
  return categories.valueSeq();
}

// @ts-ignore
export const getCategoryName: (arg0: State, arg1: CategoryId) => string =
  // @ts-ignore
  composeSelector(getCategory, category.getName);

// @ts-ignore
export const getCategoryDetails: (arg0: State, arg1: CategoryId) => string =
  // @ts-ignore
  composeSelector(getCategory, category.getDetails);

// @ts-ignore
export const getCategoryTagIds: (arg0: State, arg1: CategoryId) => string[] =
  // @ts-ignore
  composeSelector(getCategory, category.getTagIds);

export function getAllTagIdsSelector(categories: State) {
  // @ts-ignore
  const allTagIds = categories.reduce((acc, curr) => {
    acc = acc.concat(category.getTagIds(curr));
    return acc;
  }, List());
  return allTagIds.toSet().toList();
}

export const findCategoryIdByName = (categories: any, categoryName: string) => {
  const categoryState = categories.find(
    (cat: any) =>
      normalizeString(category.getName(cat) as any) ===
      normalizeString(categoryName)
  );
  return categoryState && category.getId(categoryState);
};

export const findCategoryIdSemanticMeaning = (
  categories: any,
  semanticCategory: SemanticCategory
) => {
  const categoryState = categories.find(
    (cat: any) => category.getSemanticCategory(cat) === semanticCategory
  );
  return categoryState && category.getId(categoryState);
};

export const findCategoryIdByLegacyName = (
  categories: State,
  categoryName: string
) => {
  // @ts-ignore
  const categoryState = categories.find(cat =>
    category.hasLegacyName(cat, categoryName)
  );
  return categoryState && category.getId(categoryState);
};

// @ts-ignore
export const isCategoryHidden: (arg0: State, arg1: CategoryId) => boolean =
  // @ts-ignore
  composeSelector(getCategory, category.isHidden);

export const getVisibleCategoryIds = (
  categories: State,
  categoryIds: List<CategoryId>
): List<CategoryId> =>
  categoryIds.filter(categoryId => !isCategoryHidden(categories, categoryId));

export const getVisibleCategoryIdsWithoutPrice = (
  categories: State,
  categoryIds: List<CategoryId>
): List<CategoryId> =>
  categoryIds.filter(
    categoryId =>
      !isCategoryHidden(categories, categoryId) &&
      !getCategoryName(categories, categoryId).toLowerCase().includes("price")
  );

export const getSemanticCategory: (
  arg0: State,
  arg1: CategoryId
) => SemanticCategory | undefined =
  // @ts-ignore
  composeSelector(getCategory, category.getSemanticCategory);
